"use client"
/* */
import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import clsx from 'clsx';
import '../../lib/propsContext/propsContext.mjs';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import * as Aria from 'react-aria-components';
import { DateInput } from './components/DateInput/DateInput.mjs';
import { FieldError } from '../FieldError/FieldError.mjs';
import formFieldStyles from '../FormField/FormField.module.scss.mjs';
import { Popover } from '../Popover/Popover.mjs';
import 'mobx';
import { useOverlayController } from '../../lib/controller/overlay/useOverlayController.mjs';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import { Calendar } from '../Calendar/Calendar.mjs';
import '../Button/Button.mjs';
import '@tabler/icons-react';
import '../Icon/Icon.mjs';

const DatePicker = flowComponent("DatePicker", (props) => {
  const { children, className, errorMessage, onChange, ref, ...rest } = props;
  const rootClassName = clsx(formFieldStyles.formField, className);
  const propsContext = {
    Label: {
      className: formFieldStyles.label,
      optional: !props.isRequired
    },
    FieldDescription: {
      className: formFieldStyles.fieldDescription
    },
    FieldError: {
      className: formFieldStyles.customFieldError
    }
  };
  const popoverController = useOverlayController("Popover");
  return /* @__PURE__ */ jsxs(
    Aria.DatePicker,
    {
      ref,
      ...rest,
      className: rootClassName,
      onOpenChange: (v) => popoverController.setOpen(v),
      isOpen: popoverController.isOpen,
      onChange: (value) => {
        if (onChange) {
          onChange(value);
        }
        popoverController.close();
      },
      children: [
        /* @__PURE__ */ jsx(DateInput, { isDisabled: props.isDisabled }),
        /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, children }),
        /* @__PURE__ */ jsx(FieldError, { className: formFieldStyles.fieldError, children: errorMessage }),
        /* @__PURE__ */ jsx(
          Popover,
          {
            placement: "bottom end",
            isDialogContent: true,
            controller: popoverController,
            children: /* @__PURE__ */ jsx(Calendar, {})
          }
        )
      ]
    }
  );
});

export { DatePicker, DatePicker as default };
//# sourceMappingURL=DatePicker.mjs.map
